import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FleetTipModalComponent } from '../fleet-tip-modal/fleet-tip-modal.component';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-fleet-card',
  templateUrl: './fleet-card.component.html',
  styleUrls: ['./fleet-card.component.scss'],
})
export class FleetCardComponent implements OnChanges {
  @Input() data: any;
  @Input() tokens: any;
  @Input() node: any;
  constructor(
    private dialog: MatDialog,
    private api: UserApiService,
    private message: MessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {}

  goToGpt() {
    if (this.data.status !== 1) {
      return;
    }
    this.getSeat();
  }

  seat: any;
  async getSeat() {
    try {
      this.loading = true;
      const r = await this.api.getChatgptCount('Active', this.data.car);
      this.seat = r.data;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
      this.loginFleet();
    }
  }

  loading = false;
  async loginFleet() {
    try {
      this.loading = true;
      const r = await this.api.loginFleet(
        this.data.car,
        this.seat.current,
        this.seat.duration,
        this.seat.sign,
        this.seat.times,
        this.tokens.access,
        this.tokens.current,
        this.tokens.Authorization
      );
      if (r.code === 200) {
        const usertoken = r.data.user_token;
        // const carid = r.data.car;
        // const url = `${this.node}/auth/logintoken?carid=${carid}&usertoken=${usertoken}`;
        // const url = `https://gpt.universalbus.cn/auth/logintoken?carid=${carid}&usertoken=${usertoken}`;
        const url = `https://service.universalbus.cn/auth/logintoken?carid=${this.data.car}&usertoken=${usertoken}`;
        window.open(url, '_blank');
        this.postAuthLogin(r.data);
      } else {
        this.dialog.open(FleetTipModalComponent, {
          panelClass: 'fleet-tip-dialog',
          data: this.data.car,
        });
      }
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }

  async postAuthLogin(data: any) {
    try {
      this.loading = true;
      const r = await this.api.postAuthLogin(
        data.user_token,
        data.expire_time,
        data.partner_id
      );
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }
}
